<template>
    <div class="order-loader">
        <button class="button is-light"
                :disabled="apiBusy"
                @click="loadAll()">
            Load Past Orders
        </button>
        between
        <input type="date"
               name="start_date"
               class="input date-input"
               v-model="loadStartDate">
        and
        <input type="date"
               name="end_date"
               class="input date-input"
               v-model="loadEndDate">
    </div>
</template>


<style lang="scss">
    .order-loader {
        display: inline-block;
        line-height: 2.25rem;
        color: #777;
    }
</style>

<script>
    import {mapGetters} from "vuex";
    import moment from "moment/moment"
    export default {
        data() {
            return {
                loadStartDate: moment('09/01').set('year', moment().year()).subtract(1, 'year').format('Y-MM-DD'),
                loadEndDate: moment().endOf('day').subtract(1, 'year').format('Y-MM-DD')
            }
        },
        computed: mapGetters(['apiBusy']),
        methods: {
            loadAll() {
                let confirm = window.confirm("Are you sure? This may take a minute.")
                if (confirm) {
                    this.$store.dispatch('LOAD_ALL_ORDERS', {
                        start_date: this.loadStartDate,
                        end_date: this.loadEndDate
                    })
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// orderLoader.vue?5106c399